export const getExist = (exist: string) => {
  if (exist.includes(">")) {
    return 9999;
  }
  return Number(exist);
};
